var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{class:_vm.classes,attrs:{"flat":"","ripple":false,"hide-details":"","light":"","label":_vm.name},model:{value:(_vm.editMode),callback:function ($$v) {_vm.editMode=$$v},expression:"editMode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }